import withUpSellCarousel from "../../../../UpSellCarousel/withUpSellCarousel";
import { useSelector } from "react-redux";
import { getStoreCode } from "../../../../../state/modules/config/selectors";
import ProductListingPage from "../../../ProductListingPage";
import getCarouselCategory from "./getCarouselCategory";
import PropTypes from "prop-types";

const ProductListingPageWithUpSellCarousel = withUpSellCarousel(
  ProductListingPage
);

const ProductListingPageContainer = ({ upSellCarousel, ...rest }) => {
  let carouselProps = null;
  if (!upSellCarousel) {
    const matchedCategory = useSelector(getCarouselCategory);
    const storeCode = useSelector(getStoreCode);

    if (matchedCategory && storeCode === "COM") {
      const { title, subtitle, carouselCatId } = matchedCategory;
      carouselProps = {
        title,
        subtitle,
        carouselCatId,
        ...rest
      };
    }
  }

  const getUpsellCarouselProps = upSellCarousel =>
    upSellCarousel ? upSellCarousel.props : null;

  return (
    <ProductListingPageWithUpSellCarousel
      carouselProps={carouselProps || getUpsellCarouselProps(upSellCarousel)}
      {...rest}
    />
  );
};

ProductListingPageContainer.propTypes = {
  upSellCarousel: PropTypes.string
};

export default ProductListingPageContainer;
